import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/AuthContext";

import { Login, ProtectedRoute } from "@/components/pages/Login";
import { Dashboard } from "@/components/pages/Dashboard";
import { Navigation } from "@/components/pages/Navigation";
import { Customers } from "@/components/pages/Customers";
import { Products } from "@/components/pages/Products";
import { InvoicesList } from "@/components/pages/InvoicesList";
import { InvoiceForm } from "@/components/pages/InvoiceForm";
import { InvoiceView } from "@/components/pages/InvoiceView";
import { AgreementView } from "@/components/pages/AgreementView";
import { DeliveryFormView } from "@/components/pages/DeliveryFormView";
import { StatementView } from "@/components/pages/StatementView";
import { Settings } from "@/components/pages/Settings";
import { EstimatesList } from "@/components/pages/EstimatesList";
import { EstimateForm } from "@/components/pages/EstimateForm";
import { EstimateView } from "@/components/pages/EstimateView";
import { TrialsList } from "@/components/pages/TrialsList";
import { TrialForm } from "@/components/pages/TrialForm";
import { TrialView } from "@/components/pages/TrialView";
import { CustomerPaymentPortal } from "@/components/pages/CustomerPaymentPortal";

export default function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/pay" element={<CustomerPaymentPortal />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <div className="min-h-screen bg-gray-50 print:bg-white print:min-h-0">
                    <Navigation />
                    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 print:max-w-none print:mx-0 print:px-0 print:py-0">
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/customers" element={<Customers />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/invoices" element={<InvoicesList />} />
                        <Route path="/invoices/create" element={<InvoiceForm />} />
                        <Route path="/invoices/:id/edit" element={<InvoiceForm isEdit={true} />} />
                        <Route path="/invoices/:id" element={<InvoiceView />} />
                        <Route path="/estimates" element={<EstimatesList />} />
                        <Route path="/estimates/create" element={<EstimateForm />} />
                        <Route path="/estimates/:id/edit" element={<EstimateForm isEdit={true} />} />
                        <Route path="/estimates/:id" element={<EstimateView />} />
                        <Route path="/trials" element={<TrialsList />} />
                        <Route path="/trials/create" element={<TrialForm />} />
                        <Route path="/trials/:id/edit" element={<TrialForm isEdit={true} />} />
                        <Route path="/trials/:id" element={<TrialView />} />
                        <Route path="/agreements/:id" element={<AgreementView />} />
                        <Route path="/delivery/:id" element={<DeliveryFormView />} />
                        <Route path="/statement/:id" element={<StatementView />} />
                        <Route path="/settings" element={<Settings />} />
                      </Routes>
                    </main>
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}
